<template><App :keepAliveInclude="keepAliveInclude"/></template><script>
	export default {
		onLaunch: function() {
			// console.log('App Launch')
		},
		onShow: function() {
			// console.log('App Show')
		},
		onHide: function() {
			// console.log('App Hide')
		}
	}
</script>

<style>
	/*loading样式修改*/
	/* /deep/ uni-toast .uni-toast {
		width: 100%;
		height: 100vh;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		background: rgba(0, 0, 0, .7);
	} */

	/*toast样式修改*/
	/deep/ uni-toast .uni-toast {
		width: 180px;
		height: 100px;
	}

	/*模态弹窗样式修改*/
	/*引导购买*/
	/deep/ uni-modal .uni-modal {
		border-radius: 10px;
	}

	/deep/ uni-modal .uni-modal__bd {
		padding-left: 1em;
		padding-right: 1em;
		line-height: 2;
	}

	/deep/ uni-modal .uni-modal__title {
		font-weight: bold;
	}

	/deep/ uni-modal .uni-modal__btn_default {
		font-weight: bold;
	}

	/deep/ uni-modal .uni-modal__btn_primary {
		font-weight: bold;
	}

	/*checkbox样式修改*/
	/*登录*/
	/deep/ .checkbox .uni-checkbox-input {
		border-radius: 50%;
		/* border: none; */
		/* background-color: #54CF89; */
		/* color: #fff !important; */
		background-color: #fff;
		color: #54CF89 !important;
	}

	/deep/ .uni-checkbox-input:hover {
		border-color: #d1d1d1 !important;
	}

	/*详情页弹框*/
	/deep/ .pep_modal .uni-modal {
		max-width: 400px !important;
	}
</style>